import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, BehaviorSubject, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { HttpHeaders } from '@angular/common/http';
import { GetResponse } from '../models/get-response.interface';
import { UserApps } from '../models/user-apps.interface';

@Injectable({
  providedIn: 'root'
})

export class UserAppService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getUserApps() {
    return this.httpClient.get<GetResponse<UserApps>>(`/api/v2/classhive/apps/student`);
  }

  public getUserAuthApps(): Observable<any> {
    return this.httpClient.get<any>(`/api/v2/classhive/apps/auth/list`)
      .pipe(
        map(data => {
         return data
        })
      )
  }

  public editAuthApp(appData): Observable<any> {
    // Update endpoint to `edit_auth_app`
    return this.httpClient.post<any>(`/api/v2/classhive/apps/auth/edit`, appData)
      .pipe(
        map(data => {
         return data
        })
      )
  }

  public deleteAuthDetails(appData): Observable<any> {
    // Update endpoint to `edit_auth_app`
    return this.httpClient.post<any>(`/api/v2/classhive/apps/delete`, appData)
      .pipe(
        map(data => {
         return data
        })
      )
  }


  public checkLoginDetails(appData): Observable<any> {
    return this.httpClient.post<any>(`/api/v2/classhive/apps/auth_details`, appData)
      .pipe(
        map(data => {
         return data
        })
      )
  }

  public addPersonalUserApps(appData): Observable<any> {
    return this.httpClient.post<any>(`/api/v2/classhive/apps/personal`, appData)
      .pipe(
        map(data => {
         return data
        })
      )
  }

  public getUserAppScriptLogin(user_id, app_id, params={}): Observable<any> {
    return this.httpClient
    .get<any>(
      `/api/v2/classhive/users/${user_id}/app/${app_id}/script_login`,
      {params}
    ).pipe(
        map(data => {
         return data
        })
      )
  }


}
